<template>
  <div class="cart-container">
    <PageLoader v-bind:storage="appLoading" v-bind:contain="true" />
    <ServerError v-if="ServerError" />
    
    <v-snackbar v-model="showSnackBar" color="#3EA56E" right :timeout="timeout" class="mt-12">
      <div class="d-flex align-center">
        <v-icon color="white" class="mr-2">mdi-check-circle</v-icon>
        <span class="font-weight-medium">{{ msg }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="showSnackBar = false">
          <v-icon color="white">mdi-close</v-icon>
        </v-btn>
      </div>
    </v-snackbar>

    <div class="d-flex align-center mb-8">
      <v-icon color="#3EA56E" class="mr-3">mdi-cart-outline</v-icon>
      <h2 class="section-title">My Shopping Cart</h2>
    </div>

    <v-layout wrap v-if="products && products.length > 0">
      <v-flex
        xs12
        sm6
        lg4
        xl3
        pa-2
        v-for="(item, i) in products"
        :key="i"
      >
        <CartItem
          v-bind:storage="item"
          v-bind:cardWidth="'100%'"
          @stepper="winStepper"
        />
      </v-flex>
    </v-layout>

    <div v-else-if="!appLoading" class="text-center py-12">
      <v-icon size="64" color="#e2e8f0" class="mb-4">mdi-cart-off</v-icon>
      <p class="empty-text">Your cart is currently empty.</p>
      <v-btn color="#3EA56E" dark depressed to="/Products" class="mt-4 px-8 text-none font-weight-bold rounded-lg">
        Start Shopping
      </v-btn>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CartItem from "./cartItem";
export default {
  components: {
    CartItem,
  },
  data() {
    return {
      appLoading: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      ServerError: false,
      products: [],
    };
  },
  beforeMount() {
    this.setMetaTags();
    this.getData();
  },
  methods: {
    setMetaTags() {
      document.title = "Shopping Cart & Checkout | KL-06 FARM";
      let metaDescription = document.querySelector('meta[name="description"]');
      const description = "Review your items and proceed to securely checkout at KL-06 FARM.";
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    getData() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/Cart/Getlist",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data) {
            this.products = response.data.cart;
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error("Error fetching cart data:", err);
        });
    },
    winStepper(item) {
      if (item.ref == "remove") {
        this.msg = item.response.msg;
        this.showSnackBar = true;
        if (item.getData) {
          this.getData();
        }
      }
    },
  },
};
</script>

<style scoped>
.cart-container {
  text-align: left;
}

.section-title {
  font-family: "ibmsemibold", sans-serif;
  font-size: 20px;
  color: #1a202c;
  margin: 0;
}

.empty-text {
  font-family: "sofialight", sans-serif;
  font-size: 16px;
  color: #64748b;
  margin: 0;
}

@media (max-width: 600px) {
  .section-title {
    font-size: 18px;
  }
}
</style>